// Product-text placement Type options for the products admin.
// Kept as a standalone, exported constant so the option set is a single
// source of truth that can be imported by the component and unit-tested
// directly, without instantiating the component's data() factory.
// Frozen (array + entries) to prevent accidental runtime mutation of this
// configuration; Vue 2 skips reactivity on frozen objects, which is fine
// for a static options list.
export const PRODUCT_TEXT_TYPES = Object.freeze([
  Object.freeze({id: 'name', label: 'Name'}),
  Object.freeze({id: 'number', label: 'Number'}),
  Object.freeze({id: 'team_name', label: 'Team Name'}),
  Object.freeze({id: 'captain_alternate', label: 'Captain/Alternate'}),
])
